import { AppUpdateBannerComponent } from '@components/shared/app-update-banner/app-update-banner.component';
import { TranslateService } from '@ngx-translate/core';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalStorageService } from './app/services/storage/local-storage.service';
import { HardCodedConfigService, STORAGE_LANGUAGE_KEY } from './app/services/util/hard-coded-config.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, AppUpdateBannerComponent],
  template: `<router-outlet></router-outlet><app-update-banner />`
})
export class AppComponent {
  constructor(
    private readonly translate: TranslateService,
    private readonly storageClient: LocalStorageService,
    private readonly hardCodedConfig: HardCodedConfigService
  ) {
    // Set available languages and default language
    this.translate.addLangs(this.hardCodedConfig.getAvailableLanguageCodes());
    this.translate.setDefaultLang(this.hardCodedConfig.DEFAULT_LANGUAGE);

    // Language priority: 1 - localStorage, 2 - browser language, 3 - default
    if (this.storageClient.getItem(STORAGE_LANGUAGE_KEY)) {
      const savedLang = this.storageClient.getItem(STORAGE_LANGUAGE_KEY) || '';
      // Force reload the language (fixes issue with HU to EN translations not updating)
      this.translate.reloadLang(savedLang).subscribe(() => {
        this.translate.use(savedLang);
      });
    } else {
      const browserLang = this.translate.getBrowserLang();
      const initialLang =
        browserLang && this.hardCodedConfig.getAvailableLanguageCodes().includes(browserLang) ? browserLang : this.hardCodedConfig.DEFAULT_LANGUAGE;

      this.translate.use(initialLang);
      this.storageClient.setItem(STORAGE_LANGUAGE_KEY, initialLang);
    }
  }
}
